import { api } from "@/lib/api";

let cached = null;

export async function getConfig() {
  if (!cached) {
    const r = await api.get("/config");
    cached = r.data;
  }
  return cached;
}
